/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Voice_PortugueseInputs */

const en_onboarding_voice_portuguese = /** @type {(inputs: Onboarding_Voice_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portuguese`)
};

const es_onboarding_voice_portuguese = /** @type {(inputs: Onboarding_Voice_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portugués`)
};

/**
* | output |
* | --- |
* | "Portuguese" |
*
* @param {Onboarding_Voice_PortugueseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_voice_portuguese = /** @type {((inputs?: Onboarding_Voice_PortugueseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Voice_PortugueseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_voice_portuguese(inputs)
	return en_onboarding_voice_portuguese(inputs)
});